module.exports = __webpack_public_path__ + "media/images/site/step-three-6d2c41edb819ae95aceb7ac0a886ddf2.svg";